import Vue from 'vue'
import VueStickyDirective from '@renatodeleao/vue-sticky-directive'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueClipboard from 'vue-clipboard2'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import './libs/axios'
import '@/libs/tracker'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/moment'


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Clipboard
Vue.use(VueClipboard)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueStickyDirective)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    store.commit('app/CHECK_DISPLAY_ADMIN')
    store.dispatch('app/fetchGlobalSettings')
    try {
      store.dispatch('pusher/initiatePusher')
    } catch (error) {
      console.error(error)
    }
    let { href } = router.resolve({ name: 'login' })
    if (window.location.pathname !== href) {
      store.dispatch('oauth/getAuthUser')
      .then(res => {
        let account = res.account.me
        store.commit('oauth/setUser', {type: 'id', value: account.KODE})
        store.commit('oauth/setUser', {type: 'name', value: account.NAME})
        store.commit('oauth/setUser', {type: 'email', value: account.EMAIL_ADDRESS})
        store.commit('oauth/setUser', {type: 'permissions', value: account.permissions})
        store.commit('oauth/setUser', {type: 'role', value: account.role})
        store.commit('oauth/setUser', {type: 'avatar', value: account.avatar})
        return account
      })
      .then((account) => {
        const pusher = store.state.pusher.pusherInstance
        if (!pusher) {
          console.warn('[Pusher] pusherInstance is null, skipping notification subscription.')
          return
        }
        let notification = pusher.subscribe('private-notification-' + account.KODE);
        notification.bind('notification', (data) => {
          store.dispatch('pusher/triggerNotif', data)
        })
        store.commit('pusher/addChannel', {notification})
      })
    }
  },
}).$mount('#app')
